<div
  class="hide-confirm-dialog"
  role="dialog"
  aria-modal="true"
  aria-labelledby="hide-confirm-title"
>
  <h2 id="hide-confirm-title" mat-dialog-title>
    <mat-icon aria-hidden="true">visibility_off</mat-icon>
    Hide this {{ contentLabel }}?
  </h2>

  <mat-dialog-content>
    <p>
      This {{ contentLabel }} will be removed from your feed. You won't see it again unless you
      unhide it later.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      data-testid="cancel-hide-button"
      (click)="cancel()"
      aria-label="Cancel"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      data-testid="hide-content-button"
      type="button"
      (click)="confirm()"
      [attr.aria-label]="'Hide ' + contentLabel"
    >
      Hide
    </button>
  </mat-dialog-actions>
</div>
